// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__Voobi","addWidgetButton":"Header_addWidgetButton__1k6N-","dashboardTabs":"Header_dashboardTabs__1uYuH","active":"Header_active__1DDk1"};